module.exports = __webpack_public_path__ + "static/media/flask-fill.5ca37385.svg";